import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import InputField from "components/Input";
import SystemServices from "services/System";
import DatePicker from "components/DatePicker";
import { useAuth } from "context/UseContext";
import ExportServices from "services/Export";
import ExportFinanceServices from "services/ExportFinance";

function ExportUpdateTT() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues: getValues2,
  } = useForm();
  const [loading, setLoading] = useState(false);

  // *For Handle Date
  const [ttDate, setTtDate] = useState(new Date());

  // *For Vendor Dropdown
  const [vendors, setVendors] = useState();
  const [selectedVendor, setSelectedVendor] = useState(null);

  // *For Currencies
  const [currencies, setCurrencies] = useState();
  const [exchangeRate, setExchangeRate] = useState();
  // *For Rates
  const [ttCharges, setTtCharges] = useState(0);
  const [vatCharges, setVatCharges] = useState(0);
  const [fcyAmount, setFcyAmount] = useState(0);
  const [lcyAmount, setLcyAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const [ttDetail, setTtDetail] = useState();

  // *For Payment Method
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const [selectedVia, setSelectedVia] = useState(null);

  // *For Bank Account
  const [bankAccounts, setBankAccounts] = useState([]);
  const [cashierAccounts, setCashierAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [bankAccountsGuc, setBankAccountsGuc] = useState([]);
  const [bankAccountsGws, setBankAccountsGws] = useState([]);
  const [vaultAccounts, setVaultAccounts] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [totalValue, setTotalValue] = useState(0);
  const [exchangeLoss, setExchangeLoss] = useState(0);
  const [vendorTypes, setVendorTypes] = useState([
    { id: "agent", name: "Agent" },
    { id: "broker", name: "Broker" },
    { id: "recoveryAgent", name: "Recovery & Shifting Agent" },
    { id: "portAgent", name: "Port Agent" },
  ]);
  const [selectedVendorType, setSelectedVendorType] = useState(null);
  const [filteredVendors, setFilteredVendors] = useState([]); // Holds vendors of selected type

  // *For Handle Date
  const handleTtDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setTtDate("invalid");
        return;
      }
      setTtDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Currencies
  const getCurrencies = async () => {
    try {
      let params = {
        detailed: true,
      };
      const { data } = await SystemServices.getCurrencies(params);
      setCurrencies(data?.currencies);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleExchangeLoss = () => {
    try {
      let total =
        parseFloat(totalAmount) +
        parseFloat(ttCharges) +
        parseFloat(vatCharges);
      setTotalValue(total);
      let aedTotalAmount = parseFloat(total * 3.675).toFixed(2);
      const currentExchangeRate = parseFloat(getValues2("ttRate"));

      const calculatedLoss = parseFloat(
        (currentExchangeRate * total - aedTotalAmount).toFixed(2)
      );
      let exLoss;
      if (calculatedLoss === 0) {
        exLoss = 0;
      } else if (currentExchangeRate < 3.675) {
        exLoss = Math.abs(calculatedLoss);
      } else {
        exLoss = -Math.abs(calculatedLoss);
      }

      setExchangeLoss(exLoss);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Vendor
  // const getVendorDropdown = async () => {
  //     try {
  //         const { data } = await ExportServices.getVendorDropdown();
  //         setVendors([...data?.agents, ...data?.brokers, ...data?.recoveryAgents]);
  //     } catch (error) {
  //         ErrorToaster(error);
  //     }
  // };

  const getVendorDropdown = async () => {
    try {
      const { data } = await ExportServices.getVendorDropdown();
      const allVendors = [
        ...data?.agents.map((v) => ({ ...v, type: "agent" })),
        ...data?.brokers.map((v) => ({ ...v, type: "broker" })),
        ...data?.recoveryAgents.map((v) => ({ ...v, type: "recoveryAgent" })),
        ...data?.portAgents?.map((v) => ({ ...v, type: "portAgent" })),
      ];

      setVendors(allVendors);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleSelectVendorType = (value) => {
    setSelectedVendorType(value);
    setSelectedVendor(null);
    const filtered = vendors.filter((v) => v.type === value.id);
    setFilteredVendors(filtered);
  };

  const getTTDetail = async () => {
    try {
      let params = {
        tt_id: id,
      };
      const { data } = await ExportServices.getTTDetail(params);
      setTtDetail(data?.vendor);
      handleTtDate(data?.vendor?.tt_date);

      console.log(data);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Payment Accounts
  const getPaymentAccounts = async () => {
    try {
      let params = {
        page: 1,
        limit: 1000,
      };
      const { data } = await ExportServices.getPaymentAccounts(params);
      // *Filter only vehicle account
      const vehicleAcc = data?.cashierAccounts?.rows?.filter(
        (e) => e.unit === "Shipping"
      );
      // *1003 is the cashier role ID if the login user is a cashier then show only their account
      if (user?.role_id === 1004) {
        const userId = user?.ref_id.split("-")[1];
        const filterCashier = vehicleAcc.filter((e) => e.user_id == userId);
        setCashierAccounts(filterCashier);
      } else {
        setCashierAccounts(vehicleAcc);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Banks
  const getBanks = async () => {
    try {
      let params = {
        page: 1,
        limit: 150,
      };
      const { data } = await ExportFinanceServices.getBanks(params);
      const activeBanks = data?.banks?.rows.filter(bank => bank.is_active);
      setBankAccounts(activeBanks);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Create TT
  const ExportUpdateTT = async (formData) => {
    setLoading(true);
    try {
      let obj = {
        tt_id: parseInt(id),
        vendor_id: selectedVendor?.id,
        via: selectedVia,
        vendor_name: selectedVendor?.name,
        vendor_type: selectedVendorType?.id,
        external_no: formData?.externalRef,
        fcy_amount: fcyAmount,
        ex_rate: exchangeRate,
        ex_loss: exchangeLoss,
        fcy_currency: selectedVendor?.currency,
        lcy_amount: lcyAmount,
        tt_charges: ttCharges,
        vat_charges: vatCharges,
        total_amount: (
          parseFloat(totalAmount) +
          parseFloat(ttCharges) +
          parseFloat(vatCharges)
        ).toFixed(2),
        notes: formData?.note,
        payment_method: selectedPaymentMethod?.id,
        tt_date: ttDate,
        account_name: selectedBankAccount?.name,
        account_id: selectedBankAccount?.id,
      };
      const message = await ExportServices.updateExportTT(obj);
      SuccessToaster(message.message);
      navigate("/export-tt-list");
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  // *For Handle Select Vendor
  const handleSelectVendor = (data) => {
    try {
      const exRate = currencies.find(
        (e) => e.currency === data?.currency
      )?.conversion_rate;
      console.log(data, "data");
      setSelectedVendor(data);
      setValue("ttRate", ttDetail?.ex_rate);
      setExchangeRate(ttDetail?.ex_rate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Handle Calculate
  const handleCalc = (value) => {
    console.log(value);
    try {
      let aed = value * exchangeRate;
      setFcyAmount(value);
      setLcyAmount(aed);
      setTtCharges(ttCharges);
      setVatCharges(vatCharges);
      setTotalAmount(aed);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Handle Payment Method
  const handlePaymentMethod = (data) => {
    try {
      setSelectedPaymentMethod(data);
      if (data?.id === "bank") {
        setSelectedAccount(bankAccounts[0]);
      } else {
        setSelectedAccount(null);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    if (exchangeRate) {
      handleCalc(fcyAmount);
    }
  }, [exchangeRate]);

  useEffect(() => {
    handleExchangeLoss();
  }, [exchangeRate, totalAmount, ttCharges, vatCharges]);

  useEffect(() => {
    if (id) {
      getVendorDropdown();
      getPaymentAccounts();
      getBanks();
      getCurrencies();
      getTTDetail();
      getVaultCustomers();
    }
  }, [id]);

  useEffect(() => {
    if (ttDetail) {
      setValue("externalRef", ttDetail?.external_no);
      setSelectedVendor(ttDetail?.vendor);
      setExchangeRate(ttDetail?.ex_rate);
      const vendorTypeKey = ttDetail?.vendor?.customerProfile?.type
        ? ttDetail?.vendor?.customerProfile?.type === "Recovery Agent"
          ? "Recovery & Shifting Agent"
          : ttDetail?.vendor?.customerProfile?.type
        : ttDetail?.vendor?.customerProfile?.type;
      const matchedVendorType = vendorTypes.find(
        (v) => v.name === vendorTypeKey
      );
      if (matchedVendorType) {
        setSelectedVendorType(matchedVendorType);
      }
      handleSelectVendor(ttDetail?.vendor);
      setValue("vendorType", matchedVendorType?.id);
      setValue("vendor", ttDetail?.vendor);
      let parsedFcyAmount = parseFloat(ttDetail?.fcy_amount);
      let parsedTtCharges = parseFloat(ttDetail?.tt_charges);
      let parsedVatCharges = parseFloat(ttDetail?.vat_charges);
      handleCalc(parsedFcyAmount);

      setValue("fcyAmount", parsedFcyAmount);
      setValue("ttCharges", parsedTtCharges);
      setValue("vatCharges", parsedVatCharges);
      setTtCharges(parsedTtCharges);
      setVatCharges(parsedVatCharges);

      handlePaymentMethod({
        id: ttDetail?.payment_method,
        name: ttDetail?.payment_method,
      });
      setValue("paymentMethod", {
        id: ttDetail?.payment_method,
        name: ttDetail?.payment_method,
      });
      if (ttDetail?.account) {
        setSelectedAccount(ttDetail?.account);
        setValue("account", ttDetail?.account);
      }
      setSelectedVia(ttDetail?.via);
      setValue("via", ttDetail?.via);
      setValue("exchange rate", ttDetail?.ex_rate);
      setValue("note", ttDetail?.notes || "");
    }
  }, [ttDetail]);

  const getVaultCustomers = async () => {
    try {
      let params = {
        page: 1,
        limit: 1000,
        type: "Shipping",
      };
      const { data } = await ExportServices.getPaymentAccounts(params);
      const filterData = data?.portagents?.rows?.filter(
        (e) => e.unit === "Shipping"
      );
      const filterPort = filterData.filter(
        (e) =>
          e.type_code === "L2" &&
          e.primary_series === 50003 &&
          e.user_id === selectedVendor?.id
      );

      setVaultAccounts(filterPort);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getVaultCustomers();
  }, [selectedVendor]);

  useEffect(() => {
    if (ttDetail) {
      setExchangeRate(ttDetail?.ex_rate);
      setTimeout(() => {
        setValue("ttRate", ttDetail?.ex_rate || 0);
      }, 50);
    }
  }, [ttDetail]);

  return (
    <Box
      sx={{
        m: 4,
        p: 5,
        bgcolor: Colors.white,
        borderRadius: 3,
        boxShadow: "0px 8px 18px 0px #9B9B9B1A",
      }}
    >
      <Box component="form">
        <Typography
          variant="h5"
          sx={{
            color: Colors.charcoalGrey,
            fontFamily: FontFamily.NunitoRegular,
            mb: 3,
          }}
        >
          Edit Export TT
        </Typography>
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item sm={4}>
            <DatePicker
              label={"Date"}
              value={ttDate}
              onChange={(date) => handleTtDate(date)}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              label={"External Ref No"}
              placeholder={"External Ref No"}
              error={errors?.externalRef?.message}
              register={register("externalRef", {
                required: "Please enter external ref.",
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <SelectField
              label={"Vendor Type"}
              options={vendorTypes}
              selected={selectedVendorType}
              onSelect={handleSelectVendorType}
              error={errors?.vendorType?.message}
              register={register("vendorType", {
                required: "Please select vendor type.",
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <SelectField
              label={"Vendor"}
              // options={vendors || []}  // Ensure it's always an array
              options={filteredVendors || []}
              selected={selectedVendor}
              onSelect={(value) => handleSelectVendor(value)}
              error={errors?.vendor?.message}
              register={register("vendor", {
                required: "Please select vendor.",
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              type={"number"}
              label={"FCY Amount ($)"}
              placeholder={"FCY Amount ($)"}
              InputProps={{ inputProps: { min: 0 } }}
              register={register("fcyAmount", {
                onChange: (e) =>
                  e.target.value ? handleCalc(e.target.value) : handleCalc(0),
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              disabled={true}
              label={"LCY Amount (AED)"}
              placeholder={"LCY Amount (AED)"}
              value={parseFloat(lcyAmount).toFixed(2)}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              label={"TT Rate (AED)"}
              placeholder={"TT Rate (AED)"}
              InputProps={{ inputProps: { min: 0 } }}
              register={register("ttRate", {
                onChange: (e) =>
                  e.target.value
                    ? setExchangeRate(e.target.value)
                    : exchangeRate,
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              label={"Exchange Loss/Gain"}
              placeholder={"Exchange Loss/Gain"}
              value={
                isNaN(exchangeLoss) ? "0" : parseFloat(exchangeLoss).toFixed(2)
              }
              // value={parseFloat(exchangeLoss).toFixed(2)}
              disabled={true}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              label={"TT and Bank Charges (AED)"}
              placeholder={"TT and Bank Charges (AED)"}
              error={errors?.ttCharges?.message}
              register={register("ttCharges", {
                required: "Please enter tt bank charges.",
                onChange: (e) =>
                  e.target.value ? setTtCharges(e.target.value) : ttCharges,
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              label={"VAT on Bank Charges (AED)"}
              placeholder={"VAT on Bank Charges "}
              error={errors?.vatCharges?.message}
              register={register("vatCharges", {
                required: "Please enter vat charges.",
                onChange: (e) =>
                  e.target.value ? setVatCharges(e.target.value) : vatCharges,
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <SelectField
              label={"Payment Method"}
              options={[
                {
                  id: "cash",
                  name: "Cash",
                },
                {
                  id: "bank",
                  name: "Bank",
                },
                {
                  id: "vault",
                  name: "Wallet",
                },
              ]}
              selected={selectedPaymentMethod}
              onSelect={(value) => handlePaymentMethod(value)}
              error={errors?.paymentMethod?.message}
              register={register("paymentMethod", {
                required: "Please select payment method.",
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <SelectField
              disabled={selectedPaymentMethod ? false : true}
              label={"TT Fund form Account:"}
              options={
                selectedPaymentMethod?.id === "bank"
                  ? bankAccounts
                  : selectedPaymentMethod?.id === "vault"
                  ? vaultAccounts
                  : cashierAccounts
              }
              selected={selectedAccount}
              onSelect={(value) => setSelectedAccount(value)}
              error={errors?.account?.message}
              register={register("account", {
                required: "Please select  account.",
              })}
            />
          </Grid>
          <Grid item sm={4}>
            <InputField
              disabled={true}
              label={"Total Amount (AED)"}
              placeholder={"Total Amount"}
              InputProps={{ inputProps: { min: 0 } }}
              value={(
                parseFloat(totalAmount) +
                parseFloat(ttCharges) +
                parseFloat(vatCharges)
              ).toFixed(2)}
            />
          </Grid>
          <Grid item sm={12}>
            <InputField
              label={"Accountant Notes"}
              placeholder={"Accountant Notes"}
              multiline={true}
              rows={2}
              register={register("note")}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Box sx={{ textAlign: "right" }}>
              <PrimaryButton
                title="Cancel"
                onClick={() => navigate("/export-tt-list")}
                style={{ marginRight: "1rem" }}
              />
              <PrimaryButton
                title="Update"
                // type="submit"
                type="button"
                onClick={handleSubmit(ExportUpdateTT)}
                // loading={loading}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ExportUpdateTT;
